module.exports = __webpack_public_path__ + "static/media/logo.27bdaae4.png";